import React from 'react';
import { Button } from 'antd';

export type ClosingPackageTaskModalFooterProps = {
  onClose: () => void;
  onSubmit: () => void;
  submitting: boolean;
  submitLabel: string;
  submitTestId?: string;
  submitDisabled?: boolean;
  secondaryLabel?: string;
  onSecondary?: () => void;
  secondaryTestId?: string;
};

const ClosingPackageTaskModalFooter: React.FC<ClosingPackageTaskModalFooterProps> = ({
  onClose,
  onSubmit,
  submitting,
  submitLabel,
  submitTestId,
  submitDisabled = false,
  secondaryLabel,
  onSecondary,
  secondaryTestId,
}) => (
  <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
    <Button onClick={onClose} disabled={submitting}>
      Отмена
    </Button>
    {secondaryLabel && onSecondary ? (
      <Button
        disabled={submitDisabled || submitting}
        onClick={() => void onSecondary()}
        data-testid={secondaryTestId}
      >
        {secondaryLabel}
      </Button>
    ) : null}
    <Button
      type="primary"
      loading={submitting}
      disabled={submitDisabled || submitting}
      onClick={() => void onSubmit()}
      data-testid={submitTestId}
    >
      {submitLabel}
    </Button>
  </div>
);

export default ClosingPackageTaskModalFooter;
